// Component to render appropriate document icon based on file type

import { getFileType } from "@/utils/download"
import { FilesIcon, FileTextIcon, FileX, Image } from 'lucide-react'
import type { ReactNode } from "react"
import pdfIcon from '@/assets/images/pdf.png'

    const DocumentIcon = ({url}: {url?: string}): ReactNode => {

      if(!url || url === '#') {
        return <FileX className="w-6 h-6" strokeWidth={1} />
      }

    const fileType = getFileType(url)
    switch (fileType) {
      case 'pdf':
        return <img src={pdfIcon} alt="PDF" className="w-6 h-6" />
      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
        return <FileTextIcon className="w-6 h-6" strokeWidth={1} />
        case "png":
      case "jpg":
        case "jpeg":
          case "gif":
            case "bmp":
              case "svg":
                case "webp":
        return <Image className="w-6 h-6" strokeWidth={1} />
      default:
        return <FilesIcon className="w-6 h-6" strokeWidth={1} />
    }
  }

  export default DocumentIcon;